import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyDrawer, LyDrawerContainer, LyDrawerContent } from './drawer';
import { ThemeModule } from 'alyle-ui/core';
var LyDrawerModule = /** @class */ (function () {
    function LyDrawerModule() {
    }
    LyDrawerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ThemeModule
                    ],
                    exports: [LyDrawer, LyDrawerContainer, LyDrawerContent],
                    declarations: [LyDrawer, LyDrawerContainer, LyDrawerContent],
                },] },
    ];
    /** @nocollapse */
    LyDrawerModule.ctorParameters = function () { return []; };
    return LyDrawerModule;
}());
export { LyDrawerModule };
//# sourceMappingURL=drawer.module.js.map